define('shared/initializer/form/adapters/mixins/Ajaxable',[
    '$',
    'shared/lib/RSVP'
], 
function (
    $,
    RSVP
) {
    'use strict';

    function Ctor() { }

    Ctor.prototype.doSubmit = function() {
        var me = this;
        var $form = me.$form;

        return new RSVP.Promise(function( resolve, reject ) {
            var data = $form.serialize();

            var posting = $.ajax({
                url: $form.attr('action'),
                data: data,
                traditional: true,
                type: 'POST',
                dataType: 'json'
            });

            posting
            .promise()
            .then(resolve, function( xhr, textStatus, errorThrown ){
                if (typeof errorThrown === 'string') {
                    errorThrown = new Object(errorThrown);
                }
                var error = errorThrown || new Error('Cannot reach the remote server');
                error.fatal = false;
                reject( error );
            });
        });
        
    };

    return Ctor;
});
